import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

import { Button } from './shadcn/button';

export interface CursorPaginationProps {
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSkipToStart: () => void;
  onSkipToEnd: () => void;
  totalCount?: number;
  filteredCount?: number;
  entityName?: string;
}

export const CursorPagination = ({
  currentPage,
  totalPages,
  isLoading,
  onPrev,
  onNext,
  onSkipToStart,
  onSkipToEnd,
  totalCount,
  filteredCount,
  entityName = 'facts',
}: CursorPaginationProps) => {
  const showCounts = totalCount !== undefined && filteredCount !== undefined;
  const showButtons = totalPages > 1;

  if (!showCounts && !showButtons) return null;

  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  return (
    <div className="flex items-center gap-2 text-xs whitespace-nowrap">
      {showCounts && (
        <div className="text-gray-500">
          Showing {filteredCount.toLocaleString()} of{' '}
          <span className="font-medium text-gray-600">
            {totalCount.toLocaleString()} {entityName}
          </span>
        </div>
      )}

      {showButtons && (
        <div className="flex items-center gap-0.5">
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={onSkipToStart}
            disabled={!canGoPrev || isLoading}
            aria-label="First page"
          >
            <ChevronsLeft className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={onPrev}
            disabled={!canGoPrev || isLoading}
            aria-label="Previous page"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>

          <span className="px-2 text-gray-600">
            Page <span className="font-medium">{currentPage.toLocaleString()}</span> of {totalPages.toLocaleString()}
          </span>

          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={onNext}
            disabled={!canGoNext || isLoading}
            aria-label="Next page"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={onSkipToEnd}
            disabled={!canGoNext || isLoading}
            aria-label="Last page"
          >
            <ChevronsRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};
